export default "__VITE_ASSET__BYfjeNXc__"